import { render, staticRenderFns } from "./renovateRecord.vue?vue&type=template&id=19e15e88&scoped=true"
import script from "./renovateRecord.vue?vue&type=script&lang=js"
export * from "./renovateRecord.vue?vue&type=script&lang=js"
import style0 from "./renovateRecord.vue?vue&type=style&index=0&id=19e15e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e15e88",
  null
  
)

export default component.exports